module.exports = __webpack_public_path__ + "frontend/images/white/carousel/static/account@2.png?5e2f36a92a15f9c5bd458bf65db66f41";